import { COLORS } from '~theme/colors'
import { Fonts } from '~theme/deprecated-vt/deprecated-vt-theme'

const SPACINGS = [
  '4px',
  '8px',
  '16px',
  '24px',
  '32px',
  '40px',
  '48px',
  '56px',
  '64px',
  '72px',
  '80px',
  '88px',
  '96px',
  '104px',
  '112px',
  '120px',
  '128px',
  '136px',
  '144px',
  '152px',
  '160px',
  '168px',
  '176px',
  '184px',
  '192px',
  '200px',
]

// eslint-disable-next-line
import styled from 'styled-components'

type Props = React.LabelHTMLAttributes<HTMLLabelElement> & {
  disabled?: boolean
  required?: boolean
  label: string
}

const StyledLabel = styled.label<{ disabled?: boolean }>`
  font-family: ${Fonts.families.bold};
  font-size: ${Fonts.sizes.small};
  letter-spacing: 0;
  margin-bottom: ${SPACINGS[1]};
  text-transform: uppercase;
  white-space: nowrap;
  color: ${(p) => (p.disabled ? COLORS.greys.mid : COLORS.secondary.darkBlue)};
  pointer-events: ${(p) => p.disabled && 'none'};
`

export const Label = ({ label, required, disabled, ...props }: Props) => {
  return (
    <StyledLabel disabled={disabled} {...props}>
      {label}
      {required ? '*' : ''}
    </StyledLabel>
  )
}
